
import { provideStore } from '@ngxs/store';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { AppState } from '../store/app.state';

import { ImageUploadState } from '../store/image-upload';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { httpErrorInterceptor } from '../interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

const states = [
  AppState,
  ImageUploadState
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideToastr(),
    provideStore(
      states,
      withNgxsReduxDevtoolsPlugin({ disabled: environment.production })
    ),
    provideHttpClient(
      withInterceptors([httpErrorInterceptor])
    ),
    provideClientHydration(withEventReplay())
  ]
};
